import { CDNImage } from '../../common/interfaces/cdnImage';
import { Language } from '../../common/interfaces/language';
import { TimeLineStyle, WorkflowItem } from '../../store/interfaces';
import { TaskItem } from '../../taskList/interfaces/taskTile';

/** Props for General Content Page */
export interface GeneralContentConfig {
  layout: string;
  backgroundImageEnabled: boolean;
  backgroundColor: string;
  backgroundImage?: CDNImage;
  id?: string;
}

interface BannerProps {
  bannerImageEnabled: boolean;
  bannerImage?: CDNImage;
}

interface ButtonProps {
  buttonText: string;
  buttonStyle: string;
}

interface CkContentProps {
  content: string;
  contentContainerBackgroundColor?: string;
  contentContainerOpacity?: number;
  name?: string;
  taskName?: string;
}

export interface Layout01Props extends GeneralContentConfig, CkContentProps, ButtonProps {}

export interface Layout02Props extends GeneralContentConfig, BannerProps, ButtonProps, CkContentProps {}

export interface Layout03Props extends GeneralContentConfig, BannerProps, ButtonProps, CkContentProps {}

export interface Layout04Props extends GeneralContentConfig, ButtonProps, CkContentProps {}

export interface Layout05Props extends GeneralContentConfig, ButtonProps, CkContentProps {
  mediaSource: MediaSource.URL | MediaSource.MEDIA_LIBRARY;
  mediaUrl: string | CDNImage;
  timeline: TimeLineStyle;
}

export interface Layout08Props extends GeneralContentConfig, CkContentProps {
  mediaUrl: string | CDNImage;
  title: string;
  mediaAlignment: string;
  titleColor: string;
}

export interface Layout09Props extends GeneralContentConfig, CkContentProps {
  title: string;
  items: ContentItem[];
  titleColor: string;
  contentTextColor: string;
}

export interface Layout10Props extends GeneralContentConfig {
  title: string;
  items: ContentItem[];
  titleColor: string;
  contentTextColor: string;
  contentContainerBackgroundColor?: string;
  stripColor: string;
}

interface ContentItem {
  title: string;
  description: string;
  mediaUrl?: CDNImage;
}

export enum MediaSource {
  URL = 'URL',
  MEDIA_LIBRARY = 'MEDIA_LIBRARY',
}

export interface GeneralContentProps
  extends GeneralContentConfig,
    BannerProps,
    ButtonProps,
    CkContentProps,
    Layout05Props,
    Layout08Props,
    Layout09Props,
    Layout10Props {
  loading: boolean;
  saveNGetNextWfItem: () => void;
  isICPEnabled: boolean;
  pageStartTime: Date;
  isLanguageSelectionFormOpen?: boolean;
  returnToTaskList?: boolean;
  schedulableTaskItem?: TaskItem | null;
  handleClickAwayLanguageSelection(event: MouseEvent | TouchEvent): void;
  onLanguageSubmit?(selectedLanguage: Language): void;
  languages?: Language[];
  isNextButtonDisabled?: boolean;
  getNextWorkflowItem?(): Promise<void>;
  currentWorkflowItem?: WorkflowItem;
  isNextItemAssessment?: boolean;
}

/** Props for Css */
export interface CssProps {
  backgroundColor: string;
  backgroundImage?: string;
  marginTop?: string;
  contentBgColor?: string;
  isICPEnabled?: boolean;
  isICPEnabledCorrin?: boolean;
  isLanguageSelectionFormOpen?: boolean;
  url?: string;
  titleColor?: string;
}
